import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Button } from '../../components/ui/Button';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const years = Array.from({
  length: 20
}, (_, i) => String(2026 - i));
export function ManageProfile() {
  return <div className="space-y-4 max-w-3xl" data-id="element-2186">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2187">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2188">
          Manage Profile
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2189">
          Update your personal information and account settings.
        </p>
      </div>

      <div className="rounded-xl p-6 space-y-4" style={{
      backgroundColor: '#FDF6E3'
    }} data-id="element-2190">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2191">
          <Input label="Title" defaultValue="Mr" data-id="element-2192" />
          <Input label="Company" data-id="element-2193" />
          <Input label="First Name" defaultValue="Dana" data-id="element-2194" />
          <Input label="Last Name" defaultValue="Kichen" data-id="element-2195" />
          <Input label="Address 1" defaultValue="14763 N. 90th Place" data-id="element-2196" />
          <Input label="Address 2" data-id="element-2197" />
          <Input label="City" defaultValue="Scottsdale" data-id="element-2198" />
          <Select label="State/Province *" defaultValue="AZ" options={[{
          value: 'AZ',
          label: 'Arizona'
        }, {
          value: 'CA',
          label: 'California'
        }, {
          value: 'NV',
          label: 'Nevada'
        }, {
          value: 'TX',
          label: 'Texas'
        }, {
          value: 'CO',
          label: 'Colorado'
        }]} data-id="element-2199" />
          <Input label="Zip" defaultValue="85260" data-id="element-2200" />
        </div>

        {/* Billing Address */}
        <h3 className="text-sm font-bold text-slate-700 pt-2" data-id="element-2201">
          Billing Address
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2202">
          <Input label="Billing Address 1" data-id="element-2203" />
          <Input label="Billing Address 2" data-id="element-2204" />
          <Input label="Billing City" data-id="element-2205" />
          <Select label="Billing State/Province" defaultValue="" options={[{
          value: '',
          label: '-- Select --'
        }, {
          value: 'AZ',
          label: 'Arizona'
        }, {
          value: 'CA',
          label: 'California'
        }, {
          value: 'NV',
          label: 'Nevada'
        }, {
          value: 'TX',
          label: 'Texas'
        }, {
          value: 'CO',
          label: 'Colorado'
        }]} data-id="element-2206" />
          <Input label="Billing Zip" data-id="element-2207" />
          <Input label="Phone" defaultValue="4803910222" data-id="element-2208" />
          <Input label="Email" helperText="Leave blank to keep existing email (reggieborris@yahoo.com)" data-id="element-2209" />
          <Input label="Username" helperText="Leave blank to keep existing username (student)" data-id="element-2210" />
          <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-2211" />
        </div>

        {/* License Expiration Date */}
        <div data-id="element-2212">
          <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2213">
            License Expiration Date
          </label>
          <div className="flex items-center gap-2 flex-wrap" data-id="element-2214">
            <select className="h-9 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-2215">
              {months.map(m => <option key={m} selected={m === 'November'} data-id="element-2216">
                  {m}
                </option>)}
            </select>
            <select className="h-9 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-2217">
              {years.map(y => <option key={y} selected={y === '2026'} data-id="element-2218">
                  {y}
                </option>)}
            </select>
            <button className="text-blue-600 hover:underline text-sm" data-id="element-2219">
              Click here to obtain your license expiration date from ADRE
            </button>
          </div>
        </div>

        <div className="pt-2" data-id="element-2220">
          <Button data-id="element-2221">Update</Button>
        </div>
      </div>
    </div>;
}